module.exports = __webpack_public_path__ + "assets/img/git.cbd046eb.png";